import React, { useEffect, useState } from "react";
import { Alert, AlertTitle } from "@mui/material";
import { Link } from "@mui/material";
import { Typography } from "@mui/material";
import { Redirect } from "react-router";
export function CancelAppointmentSuccess(props) {
  const [count, setCount] = useState(30);
  useEffect(() => {
    const interval = setInterval(() => {
      if (count > 0) {
        let time = count;
        setCount(time - 1);
      } else {
        setCount("Redirecting...");
      }
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  });

  if (count === 0) {
    return (
      <Redirect
        to={`/Appointments/AppointmentBooking${window.location.search}`}
      />
    );
  } else {
    return (
      <Alert
        severity="success"
        variant="filled"
        sx={{
          mt: {
            xs: 3,
            sm: 2
          },
          mb: 2,
        }}
      >
        <AlertTitle>
          Your appointment has been cancelled as requested
        </AlertTitle>
        <br />
        <Typography>
          We will contact you via telephone to rearrange your appointment.
        </Typography>
        <br />
        <Typography>
          {" "}
          If 7 days has passed and you have not received a telephone call, get
          in touch with us through our website -{" "}
          <Link
            href="https://www.connecthealth.co.uk/contact/"
            target="_blank"
            rel="noopener"
            color="inherit"
            underline="always"
          >
            https://www.connecthealth.co.uk/contact/
          </Link>
        </Typography>
        <Typography>
          You will also find information about your service, including opening
          times, services offered and who your clinicians are, on our website.
        </Typography>
        <br />
        <Typography>
          {" "}
          Please note, we are experiencing a high demand for our services, and
          our next available appointment may be later than you were originally
          offered.
        </Typography>
        <br />
        <Typography>This page will redirect in {count}.</Typography>
      </Alert>
    );
  }
}
